import CustomerForm from "./CustomerForm";
import React from 'react';

const NewCustomer = () => {
  return (
    <CustomerForm title="New Customer" />
  )
}

export default NewCustomer;